import { reactiveSetArray, set } from '@shopworx/services/util/store.helper';
import { sortArray } from '@shopworx/services/util/sort.service';
import HourService from '@shopworx/services/api/hour.service';

const REPORTS = {
  hour: 'hourlyenergydashboard',
  shift: 'shiftenergydashboard',
};

export default {
  namespaced: true,
  state: {
    loading: false,
    siteId: null,
    currentTime: null,
    serverTime: null,
    currentShift: null,
    currentHour: null,
    displayHour: null,
    currentDate: null,
    selectedView: 'shift',
    selectedTheme: 'dark',
    config: {},
    meters: [],
    shifts: [],
    themes: ['light', 'dark'],
    views: ['shift', 'hour'],
    theme: {
      isDark: true,
      themes: {
        dark: {
          cardbg: '#15191E',
          subtitlecolor: '#A1A3A5',
          titlecolor: '#FFFFFF',
          error: '#ED5353',
          success: '#21C77C',
        },
        light: {
          cardbg: '#FFFFFF',
          subtitlecolor: '#333333',
          titlecolor: '#15191E',
          error: '#FF5252',
          success: '#21C77C',
        },
      },
    },
  },
  mutations: {
    setLoading: set('loading'),
    setSiteId: set('siteId'),
    setCurrentTime: set('currentTime'),
    setServerTime: set('serverTime'),
    setCurrentShift: set('currentShift'),
    setCurrentHour: set('currentHour'),
    setDisplayHour: set('displayHour'),
    setCurrentDate: set('currentDate'),
    setSelectedView: set('selectedView'),
    setMeters: set('meters'),
    setShifts: set('shifts'),
    setMeter: reactiveSetArray('meters'),
    setSelectedTheme: set('selectedTheme'),
    setConfig(state, payload) {
      state.config = { ...payload };
    },
    setTheme: set('theme'),
  },
  actions: {

    getShifts: async ({ commit, dispatch }) => {
      const records = await dispatch(
        'element/getRecords',
        { elementName: 'businesshours', query: '?sortquery=sortindex==1' },
        { root: true },
      );
      if (records && records.length) {
        commit('setShifts', records);
        return true;
      }
      return false;
    },

    getServerTime: async ({ commit }) => {
      try {
        const { data } = await HourService.getCurrentTime();
        if (data && data.results) {
          commit('setCurrentTime', data.results);
          commit('setServerTime', data.results);
          return data.results;
        }
        return false;
      } catch (e) {
        return false;
      }
    },

    getBusinessTime: async ({ commit, dispatch, state }) => {
      let serverTime = await dispatch('getServerTime');
      if (!serverTime) serverTime = Date.now();

      try {
        const data = await dispatch('calendar/getBusinessTime', serverTime, { root: true });
        if (data && data.date) {
          let finalTs;
          const dateStr = data.date.toString();

          if (dateStr.length === 8) {
            const year = parseInt(dateStr.substring(0, 4), 10);
            const month = parseInt(dateStr.substring(4, 6), 10) - 1;
            const day = parseInt(dateStr.substring(6, 8), 10);
            finalTs = new Date(year, month, day).getTime();
          } else if (data.date > 1577836800000) {
            finalTs = data.date;
          } else {
            finalTs = new Date(serverTime).setHours(0, 0, 0, 0);
          }

          const newShift = data.shiftName || 'Shift 1';
          if (state.currentShift !== newShift) commit('setCurrentShift', newShift);
          if (state.currentDate !== finalTs) commit('setCurrentDate', finalTs);
          if (data.hour) commit('setCurrentHour', data.hour);
          if (data.displayHour) commit('setDisplayHour', data.displayHour);
          return true;
        }
        throw new Error('Calendar missing');
      } catch (e) {
        const fallbackTs = new Date(serverTime).setHours(0, 0, 0, 0);
        commit('setCurrentDate', fallbackTs);
        return true;
      }
    },

    getMeters: async ({
      state, commit, dispatch, rootState,
    }) => {
      const {
        selectedView, currentDate, currentShift, currentHour, currentTime,
      } = state;

      if (!currentDate) return false;

      let activeSite = state.siteId;
      if (!activeSite && rootState.user) {
        activeSite = rootState.user.activeSite || rootState.user.activeSiteId;
      }
      if (!activeSite) {
        try {
          const lUser = JSON.parse(localStorage.getItem('user') || '{}');
          activeSite = lUser.activeSite || lUser.activeSiteId;
        } catch (e) { /* ignore */ }
      }
      if (!activeSite) activeSite = localStorage.getItem('activeSiteId');
      if (!activeSite) return false;

      const dateObj = new Date(currentDate);
      const year = dateObj.getFullYear();
      const month = String(dateObj.getMonth() + 1).padStart(2, '0');
      const day = String(dateObj.getDate()).padStart(2, '0');
      const formattedDate = Number(`${year}${month}${day}`);

      const payload = {
        siteid: activeSite,
        dateVal: formattedDate,
      };

      if (selectedView === 'hour') {
        payload.hourVal = currentHour;
      } else {
        payload.shiftVal = currentShift;
      }

      try {
        const data = await dispatch(
          'report/executeReport',
          { reportName: REPORTS[selectedView || 'shift'], payload },
          { root: true },
        );

        if (data) {
          let parsedData = data;
          if (typeof parsedData === 'string') parsedData = JSON.parse(parsedData);
          if (parsedData && parsedData.reportData) {
            const inner = parsedData.reportData;
            parsedData = typeof inner === 'string' ? JSON.parse(inner) : inner;
          }

          const meters = parsedData.meters || [];
          const mappedMeters = meters.map((m) => ({
            ...m,
            updatedAt: m.updatedAt || currentTime,
          }));
          commit('setMeters', sortArray(mappedMeters, 'metername'));
          return true;
        }
      } catch (e) {
        return false;
      }
      return false;
    },
  },
  getters: {
    totalMeters: ({ meters }) => meters.length,
  },
};
